import type {Integration, IntegrationCreateInput, IntegrationListQueryParams} from 'src/core/data/api/Integration';
import BaseService from './base-service';

export default class IntegrationService extends BaseService {
  constructor() {
    super('integration');
  }

  list(query?: IntegrationListQueryParams): Promise<Integration[]> {
    return super.list(query);
  }

  save(data: IntegrationCreateInput): Promise<Integration> {
    return super.save(data);
  }

  update(data: Integration): Promise<Integration> {
    return super.update(data);
  }

  remove(id: number): Promise<Integration> {
    return super.remove(id);
  }
}
